export var RAMP_TIME = 0.05; // 50 ms ramp
export var nullEventHandler = function (ev) {
    /* empty body */
};
export var DECODE_TIMEOUT = 5000; // timeout decode after 5 seconds
export var PlayMode;
(function (PlayMode) {
    PlayMode[PlayMode["BinauralInPhase"] = 1] = "BinauralInPhase";
    PlayMode[PlayMode["BinauralOutOfPhase"] = 2] = "BinauralOutOfPhase";
    PlayMode[PlayMode["MonoauralLeft"] = 3] = "MonoauralLeft";
    PlayMode[PlayMode["MonoauralRight"] = 4] = "MonoauralRight";
    PlayMode[PlayMode["Diotic"] = 1] = "Diotic";
    PlayMode[PlayMode["Dichotic"] = 2] = "Dichotic";
})(PlayMode || (PlayMode = {}));
